import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  Backdrop,
  Modal,
  Typography,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from '@mui/material';

import { UserIcon } from '@icons';

import { useStyles } from './styles';

interface IProfileCompletionModalViewProps {
  open: boolean;
  name: string;
  gender: string;
  onSubmit: () => void;
  onNameChange: (value: string) => void;
  onGenderChange: (value: string) => void;
  isSubmitting: boolean;
}

const ProfileCompletionModalView = ({
  open,
  name,
  gender,
  onSubmit,
  onNameChange,
  onGenderChange,
  isSubmitting,
}: IProfileCompletionModalViewProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const isFormValid = name.trim().length > 0 && (gender === 'male' || gender === 'female');

  return (
    <Modal sx={classes.root} open={open} components={{ Backdrop }}>
      <Box component="div" sx={classes.container}>
        <Box component="div" sx={classes.iconContainer}>
          <UserIcon />
        </Box>
        <Typography sx={classes.title}>
          {t('profileCompletion.title')}
        </Typography>
        <Typography sx={classes.subtitle}>
          {t('profileCompletion.subtitle')}
        </Typography>

        <Box sx={classes.form}>
          <TextField
            fullWidth
            label={t('profileCompletion.nameLabel')}
            placeholder={t('profileCompletion.namePlaceholder')}
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            sx={classes.input}
            inputProps={{ 'aria-label': 'name' }}
          />

          <FormControl component="fieldset" sx={classes.formControl}>
            <Typography component="label" sx={classes.genderLabel}>
              {t('profileCompletion.genderLabel')}
            </Typography>
            <RadioGroup
              row
              value={gender}
              onChange={(e) => onGenderChange(e.target.value)}
              sx={classes.radioGroup}
            >
              <FormControlLabel
                value="male"
                control={<Radio sx={classes.radio} />}
                label={t('profileCompletion.male')}
              />
              <FormControlLabel
                value="female"
                control={<Radio sx={classes.radio} />}
                label={t('profileCompletion.female')}
              />
            </RadioGroup>
          </FormControl>

          <Button
            sx={classes.button}
            onClick={onSubmit}
            disabled={!isFormValid || isSubmitting}
          >
            {t('profileCompletion.submit')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ProfileCompletionModalView;
